// src/pages/Panels/PanelFormModal.jsx
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Textarea,
    useToast,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { createPanel, getTests, updatePanel } from '../../../api';

export default function PanelFormModal({ isOpen, onClose, fetchData, panel }) {
    const [form, setForm] = useState({ name: '', description: '', tests: [] });
    const [loading, setLoading] = useState(false);
    const [testsOptions, setTestsOptions] = useState([]);
    const toast = useToast();

    // Load tests for selection
    const fetchTests = async () => {
        const res = await getTests();
        if (res.success) {
            setTestsOptions(
                res?.data?.items?.map((t) => ({ value: t._id, label: t.name }))
            );
        }
    };

    useEffect(() => {
        fetchTests();
    }, []);

    useEffect(() => {
        if (panel) {
            setForm({
                name: panel.name,
                description: panel.description,
                tests: panel.tests?.map((t) => t._id) || [],
            });
        } else {
            setForm({ name: '', description: '', tests: [] });
        }
    }, [panel]);

    const handleSubmit = async () => {
        setLoading(true);
        const payload = {
            name: form.name,
            description: form.description,
            tests: form.tests,
        };
        const res = panel
            ? await updatePanel(panel._id, payload)
            : await createPanel(payload);

        setLoading(false);

        if (res.success) {
            toast({ status: 'success', title: res.message });
            fetchData();
            onClose();
        } else {
            toast({ status: 'error', title: res.error });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{panel ? 'Edit Panel' : 'New Panel'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl mb={3} isRequired>
                        <FormLabel>Name</FormLabel>
                        <Input
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                        />
                    </FormControl>
                    <FormControl mb={3}>
                        <FormLabel>Description</FormLabel>
                        <Textarea
                            value={form.description}
                            onChange={(e) =>
                                setForm({ ...form, description: e.target.value })
                            }
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Tests</FormLabel>
                        <Select
                            isMulti
                            options={testsOptions}
                            value={testsOptions.filter((opt) =>
                                form.tests.includes(opt.value)
                            )}
                            onChange={(selected) =>
                                setForm({
                                    ...form,
                                    tests: selected.map((s) => s.value),
                                })
                            }
                            placeholder="Select tests"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>
                        {panel ? 'Update' : 'Create'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
